/**
 * Lean product image ladder (4:5) — max 5 unique Cloudflare widths per asset.
 * 400  → cart / checkout / zoom thumbs
 * 800  → PLP + PDP mobile
 * 1200 → PLP desktop
 * 1600 → PDP gallery + zoom preview (shared cache)
 * 3200 → zoom full (mobile + desktop)
 *
 * Always pass width+height with fit=cover so CF crops to exact 4:5
 * (scale-down alone keeps the source ratio and can leave slight mismatches).
 */

import { mediaUrl, mediaSrcSet } from "./cfImage";

export const PRODUCT_IMG_WIDTHS = {
  cart: 400,
  listMobile: 800,
  listDesktop: 1200,
  pdp: 1600,
  zoomFull: 3200,
};

const q = 90;

/** Exact 4:5 box — Cloudflare crops overflow toward center. */
function size4x5(width, quality = q) {
  return {
    width,
    height: Math.round((width * 5) / 4),
    fit: "cover",
    quality,
  };
}

export const PRODUCT_IMG = {
  list: {
    default: size4x5(PRODUCT_IMG_WIDTHS.listDesktop),
    srcSet: [
      {
        ...size4x5(PRODUCT_IMG_WIDTHS.listMobile),
        w: PRODUCT_IMG_WIDTHS.listMobile,
      },
      {
        ...size4x5(PRODUCT_IMG_WIDTHS.listDesktop),
        w: PRODUCT_IMG_WIDTHS.listDesktop,
      },
    ],
    sizes: "(max-width: 600px) 50vw, (max-width: 900px) 33vw, 25vw",
  },
  pdp: {
    default: size4x5(PRODUCT_IMG_WIDTHS.pdp),
    srcSet: [
      {
        ...size4x5(PRODUCT_IMG_WIDTHS.listMobile),
        w: PRODUCT_IMG_WIDTHS.listMobile,
      },
      { ...size4x5(PRODUCT_IMG_WIDTHS.pdp), w: PRODUCT_IMG_WIDTHS.pdp },
    ],
    sizes: "(max-width: 900px) 100vw, (max-width: 1200px) 50vw, 35vw",
  },
  zoom: {
    preview: size4x5(PRODUCT_IMG_WIDTHS.pdp),
    full: size4x5(PRODUCT_IMG_WIDTHS.zoomFull, 85),
    thumb: size4x5(PRODUCT_IMG_WIDTHS.cart),
  },
  cart: size4x5(PRODUCT_IMG_WIDTHS.cart),
};

export function productImageUrl(filesUrl, path, imgVersion, transform) {
  return mediaUrl(filesUrl, path, { ...transform, version: imgVersion });
}

export function productImageSrcSet(filesUrl, path, imgVersion, variants) {
  return mediaSrcSet(filesUrl, path, variants, { version: imgVersion });
}
